import { useFolderListSectionQuery } from 'generated/graphql';
import React from 'react';

export interface IData {
  id: string;
  fileCount: number;
  fileName: string;

}

export function useQuery(projectId: string) {
  const tuple = useFolderListSectionQuery({
    variables: {
      options: {
        filter: {
          projectId: projectId
        }
      }
    },
    skip: projectId === ''
  });

  return React.useMemo(
    () => {
      const data: IData[] = tuple.data?.folders.map((node) => ({
        id: node.id,
        fileCount: node.fileCount,
        fileName: node.name
      })) ?? [];

      return {
        ...tuple,
        data
      };
    },
    [tuple]
  );
}
